module.exports = __webpack_public_path__ + "static/media/Brygge.dd6fd527.m4a";